// Real WF GOTOWY™ sample pages (Tom 1), WebP hosted in Impultienda Recursos.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/0cf29107-22ad-4f60-9e05-b6a25688abcc/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [{
  src: BASE + '1792376951003_wf-sample-lekcja-1-d6b78da1.webp',
  label: 'Tom 1 · Lekcja klasy 1–3',
  title: 'Ruch i sygnały – minuta po minucie',
  text: 'Cele, sprzęt, rozgrzewka, część główna i zakończenie – cała lekcja zaplanowana na 45 minut.'
}, {
  src: BASE + '1792376955516_wf-sample-karta-pracy-aed9c4c7.webp',
  label: 'Tom 1 · Karta pracy klasy 1–3',
  title: 'Moje ciało w ruchu',
  text: 'Karta pracy do wydruku z dużymi polami i zadaniami dla najmłodszych uczniów.'
}, {
  src: BASE + '1792376945838_wf-sample-plan-roczny-30ec9c58.webp',
  label: 'Tom 1 · Plan roczny',
  title: 'Plan roczny · Klasy 1–3',
  text: 'Przegląd całego roku szkolnego miesiąc po miesiącu – wiesz, co realizujesz i kiedy.'
}, {
  src: BASE + '1792376960361_wf-sample-karta-obwodu-2026bf34.webp',
  label: 'Tom 1 · Karta pracy klasy 4–6',
  title: 'Moja karta obwodu',
  text: 'Uczniowie zapisują swoje wyniki na stacjach obwodu i śledzą własne postępy.'
}, {
  src: BASE + '1792376965005_wf-sample-plakat-rutyny-56ad474a.webp',
  label: 'Tom 1 · Plakat',
  title: 'Rutyny na WF-ie',
  text: 'Początek, przejścia i zakończenie lekcji – plakat do wydruku i powieszenia na sali.'
}];
